module.exports = __webpack_public_path__ + "static/my-bed-a789737be70ff175d145b8f4aaf649c9.png";